// Relative imports (not `@/`): jest has no alias mapping, and this guard is unit-tested.
import { addCashflowBudgetDateToParams } from './budget-date-param-helper';
import { redirectToRedesignIfEnabled } from '../utils/redesign';

// The beforeEnter of the Vue 2 cashflow routes (Home, CashflowApp).
//
// A redirect to the redesign is a full page load, so the pending navigation is deliberately
// left unresolved: next(false) would reject the router.replace that StateRouter awaits.
//
// Order matters. The budget-date redirect (/home -> /home/current) re-enters the same route,
// which runs this guard a second time. The redesign check runs on that final pass only: it
// consumes the one-time escape-hatch marker (redesign.js), so running it on the first pass as
// well consumed the marker and then sent the escaped customer straight back to v3.
// eslint-disable-next-line import/prefer-default-export
export function cashflowGuard(basePath) {
  return async (to, _, next) => {
    const budgetDateRedirect = addCashflowBudgetDateToParams(basePath, to);
    if (budgetDateRedirect) {
      next(budgetDateRedirect);
      return;
    }
    if (await redirectToRedesignIfEnabled(to)) {
      return;
    }
    next();
  };
}
